function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 2.5C17.2383 2.5 21.5 6.7617 21.5 12C21.5 17.2383 17.2383 21.5 12 21.5C6.7617 21.5 2.5 17.2383 2.5 12C2.5 6.7617 6.7617 2.5 12 2.5ZM12 3.925C7.54735 3.925 3.925 7.54735 3.925 12C3.925 16.4527 7.54735 20.075 12 20.075C16.4527 20.075 20.075 16.4527 20.075 12C20.075 7.54735 16.4527 3.925 12 3.925ZM11.6781 7.34063C12.0724 7.34063 12.3906 7.65983 12.3906 8.05313V12.254L15.6254 14.1825C15.9626 14.3849 16.0738 14.8219 15.8724 15.1601C15.7384 15.3833 15.5019 15.5078 15.2596 15.5078C15.1352 15.5078 15.0098 15.4755 14.8948 15.408L11.3133 13.2715C11.0986 13.1423 10.9656 12.9095 10.9656 12.6587V8.05313C10.9656 7.65983 11.2848 7.34063 11.6781 7.34063Z",
  fill: "#FF1D6C"
});

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.bc0768fd.svg";
export { ForwardRef as ReactComponent };